export const styles = (theme) => ({
  boxFooter: {
    position: "fixed",
    bottom: 0,
    zIndex: 1201,
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "1.5",
    width: "100%",
  },
});
